import type { ReactNode } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import ICSButton from '../../components/ICS/Button/ICSButton'
type AcceptableUsagePolicyProps = {
  policy: ReactNode
  accept: () => void
  decline: () => void
}

const AcceptableUsagePolicy = ({
  policy,
  accept,
  decline
}: AcceptableUsagePolicyProps) => {
  return (
    <Modal
      isOpen
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
      modalClassName="aup-modal"
      contentClassName="aup-modal-content"
    >
      <div className="aup-header-container">
        <ModalHeader
          className={'ics-modal-header aup-header'}
          id="login_img"
        ></ModalHeader>
      </div>
      <ModalBody className="aup-modal-body">
        <div className="aup-text">{policy}</div>
      </ModalBody>
      <ModalFooter className="aup-footer">
        <ICSButton
          id="Acceptable_Usage_Policy_Accept"
          width={60}
          useSubmitBehavior={true}
          type="success"
          onClick={accept}
          className="aup-accept"
        >
          Accept
        </ICSButton>
        <ICSButton
          id="Acceptable_Usage_Policy_Decline"
          width={60}
          useSubmitBehavior={true}
          type="danger"
          onClick={decline}
          className="aup-decline"
        >
          Decline
        </ICSButton>
      </ModalFooter>
    </Modal>
  )
}

export default AcceptableUsagePolicy
